import { PriceTable } from "../components/PriceTable";
import { useSearchParams } from "react-router-dom";

export function TvPage() {
  const [searchParams] = useSearchParams();
  const rotation = searchParams.get("r") || "90";

  return (
    <div className="page-tv-container">
      <div className={`tv-rotate-${rotation}`}>
        <PriceTable displayMode="signage" />
      </div>
    </div>
  );
}
